import * as r from "react";
import { j as b, u as O, P as S } from "./radix-common-Dx8bZddK.js";
function T(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Z(e, t) {
  const n = r.createContext(t), s = (c) => {
    const { children: i, ...a } = c, l = r.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ b.jsx(n.Provider, { value: l, children: i });
  };
  s.displayName = e + "Provider";
  function o(c) {
    const i = r.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${c}\` must be used within \`${e}\``);
  }
  return [s, o];
}
function _(e, t = []) {
  let n = [];
  function s(c, i) {
    const a = r.createContext(i), l = n.length;
    n = [...n, i];
    const u = (f) => {
      var g;
      const { scope: m, children: p, ...v } = f, C = ((g = m == null ? void 0 : m[e]) == null ? void 0 : g[l]) || a, h = r.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ b.jsx(C.Provider, { value: h, children: p });
    };
    u.displayName = c + "Provider";
    function d(f, m) {
      var C;
      const p = ((C = m == null ? void 0 : m[e]) == null ? void 0 : C[l]) || a, v = r.useContext(p);
      if (v) return v;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${c}\``);
    }
    return [u, d];
  }
  const o = () => {
    const c = n.map((i) => r.createContext(i));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || c;
      return r.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: l } }),
        [a, l]
      );
    };
  };
  return o.scopeName = e, [s, j(o, ...t)];
}
function j(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const s = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(c) {
      const i = s.reduce((a, { useScope: l, scopeName: u }) => {
        const f = l(c)[`__scope${u}`];
        return { ...a, ...f };
      }, {});
      return r.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var x = globalThis != null && globalThis.document ? r.useLayoutEffect : () => {
}, U = r[" useInsertionEffect ".trim().toString()] || x;
function $({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: s
}) {
  const [o, c, i] = D({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, l = a ? e : o;
  {
    const d = r.useRef(e !== void 0);
    r.useEffect(() => {
      const f = d.current;
      f !== a && console.warn(
        `${s} is changing from ${f ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = a;
    }, [a, s]);
  }
  const u = r.useCallback(
    (d) => {
      var f;
      if (a) {
        const m = L(d) ? d(e) : d;
        m !== e && ((f = i.current) == null || f.call(i, m));
      } else
        c(d);
    },
    [a, e, c, i]
  );
  return [l, u];
}
function D({
  defaultProp: e,
  onChange: t
}) {
  const [n, s] = r.useState(e), o = r.useRef(n), c = r.useRef(t);
  return U(() => {
    c.current = t;
  }, [t]), r.useEffect(() => {
    var i;
    o.current !== n && ((i = c.current) == null || i.call(c, n), o.current = n);
  }, [n, o]), [n, s, c];
}
function L(e) {
  return typeof e == "function";
}
function F(e, t) {
  return r.useReducer((n, s) => t[n][s] ?? n, e);
}
var E = (e) => {
  const { present: t, children: n } = e, s = k(t), o = typeof n == "function" ? n({ present: s.isPresent }) : r.Children.only(n), c = O(s.ref, W(o));
  return typeof n == "function" || s.isPresent ? r.cloneElement(o, { ref: c }) : null;
};
E.displayName = "Presence";
function k(e) {
  const [t, n] = r.useState(), s = r.useRef(null), o = r.useRef(e), c = r.useRef("none"), i = e ? "mounted" : "unmounted", [a, l] = F(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return r.useEffect(() => {
    const u = P(s.current);
    c.current = a === "mounted" ? u : "none";
  }, [a]), x(() => {
    const u = s.current, d = o.current;
    if (d !== e) {
      const m = c.current, p = P(u);
      e ? l("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), x(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, f = (p) => {
        const C = P(s.current).includes(p.animationName);
        if (p.target === t && C && (l("ANIMATION_END"), !o.current)) {
          const h = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = h);
          });
        }
      }, m = (p) => {
        p.target === t && (c.current = P(s.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: r.useCallback((u) => {
      s.current = u ? getComputedStyle(u) : null, n(u);
    }, [])
  };
}
function P(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function W(e) {
  var s, o;
  let t = (s = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : s.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var B = r[" useId ".trim().toString()] || (() => {
}), G = 0;
function q(e) {
  const [t, n] = r.useState(B());
  return x(() => {
    n((s) => s ?? String(G++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var R = "Collapsible", [V, H] = _(R), [z, A] = V(R), J = r.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: s,
      defaultOpen: o,
      disabled: c,
      onOpenChange: i,
      ...a
    } = e, [l, u] = $({
      prop: s,
      defaultProp: o ?? !1,
      onChange: i,
      caller: R
    });
    return /* @__PURE__ */ b.jsx(
      z,
      {
        scope: n,
        disabled: c,
        contentId: q(),
        open: l,
        onOpenToggle: r.useCallback(() => u((d) => !d), [u]),
        children: /* @__PURE__ */ b.jsx(
          S.div,
          {
            "data-state": M(l),
            "data-disabled": c ? "" : void 0,
            ...a,
            ref: t
          }
        )
      }
    );
  }
);
J.displayName = R;
var I = "CollapsibleTrigger", K = r.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...s } = e, o = A(I, n);
    return /* @__PURE__ */ b.jsx(
      S.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": M(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...s,
        ref: t,
        onClick: T(e.onClick, o.onOpenToggle)
      }
    );
  }
);
K.displayName = I;
var w = "CollapsibleContent", Q = r.forwardRef(
  (e, t) => {
    const { forceMount: n, ...s } = e, o = A(w, e.__scopeCollapsible);
    return /* @__PURE__ */ b.jsx(E, { present: n || o.open, children: ({ present: c }) => /* @__PURE__ */ b.jsx(X, { ...s, ref: t, present: c }) });
  }
);
Q.displayName = w;
var X = r.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: s, children: o, ...c } = e, i = A(w, n), [a, l] = r.useState(s), u = r.useRef(null), d = O(t, u), f = r.useRef(0), m = f.current, p = r.useRef(0), v = p.current, C = i.open || a, h = r.useRef(C), g = r.useRef(void 0);
  return r.useEffect(() => {
    const N = requestAnimationFrame(() => h.current = !1);
    return () => cancelAnimationFrame(N);
  }, []), x(() => {
    const N = u.current;
    if (N) {
      g.current = g.current || {
        transitionDuration: N.style.transitionDuration,
        animationName: N.style.animationName
      }, N.style.transitionDuration = "0s", N.style.animationName = "none";
      const y = N.getBoundingClientRect();
      f.current = y.height, p.current = y.width, h.current || (N.style.transitionDuration = g.current.transitionDuration, N.style.animationName = g.current.animationName), l(s);
    }
  }, [i.open, s]), /* @__PURE__ */ b.jsx(
    S.div,
    {
      "data-state": M(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !C,
      ...c,
      ref: d,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": v ? `${v}px` : void 0,
        ...e.style
      },
      children: C && o
    }
  );
});
function M(e) {
  return e ? "open" : "closed";
}
export {
  J as C,
  E as P,
  $ as a,
  _ as b,
  T as c,
  q as d,
  Z as e,
  Q as f,
  K as g,
  x as u
};
//# sourceMappingURL=radix-collapsible-CI9x1I_j.js.map
